import { render, staticRenderFns } from "./MsgListBoxCmp.vue?vue&type=template&id=2d36e471&"
import script from "./MsgListBoxCmp.vue?vue&type=script&lang=js&"
export * from "./MsgListBoxCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports